import type { ErrorLike } from '@apollo/client'

/** The codes the API attaches to a thrown error (V1.md section 5). */
export type ApiErrorCode =
  'UNAUTHENTICATED' | 'FORBIDDEN' | 'NOT_FOUND' | 'BAD_USER_INPUT' | 'INTERNAL'

interface GraphQLErrorLike {
  message: string
  extensions?: { code?: unknown }
}

/**
 * The first `extensions.code` on an Apollo error.
 *
 * Read off the shape rather than with `instanceof CombinedGraphQLErrors`,
 * because that is a class from another package and the check silently answers
 * false whenever two copies of it end up in one process. The API's own error
 * formatter avoids the same trap for the same reason.
 */
export function apiErrorCode(error: ErrorLike | undefined): ApiErrorCode | undefined {
  if (!error) return undefined

  const errors = (error as { errors?: readonly GraphQLErrorLike[] }).errors
  const code = errors?.[0]?.extensions?.code
  return typeof code === 'string' ? (code as ApiErrorCode) : undefined
}

export function isUnauthenticated(error: ErrorLike | undefined): boolean {
  return apiErrorCode(error) === 'UNAUTHENTICATED'
}
